import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { endpoints, ID } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { dashboardRefreshIntervalSelector } from '../../../../redux/modules/organizationGroup/selectors';
import { StatusTabArray, StatusTabKeys } from '../tabs';

export const QUERY_KEY_STATUS_COUNTS = 'status-tab-counts';

const STATUS_COUNTS_FETCH_INTERVAL = 5000;

type StatusTabCount = Partial<
  Record<StatusTabKeys, { validCount: number; invalidCount: number }>
>;

export const useStatusTabCounts = ({
  queueId,
  statusTabs,
}: {
  queueId: ID;
  statusTabs: StatusTabArray;
}) => {
  const refreshInterval =
    useSelector(dashboardRefreshIntervalSelector) ??
    STATUS_COUNTS_FETCH_INTERVAL;

  return useQuery({
    queryKey: [QUERY_KEY_STATUS_COUNTS, queueId] as const,
    queryFn: ({ queryKey }) => api.request(endpoints.queues.get(queryKey[1])),
    select: ({ counts }) => {
      return statusTabs.reduce<StatusTabCount>(
        (acc, statusTab) =>
          Object.assign(acc, {
            [statusTab.key]: {
              validCount: statusTab.getValidCount(counts),
              invalidCount: statusTab.getInvalidCount(counts),
            },
          }),
        {}
      );
    },
    refetchInterval: refreshInterval,
    // if we want to call this hook conditionally we pass zero as queueId
    enabled: !!queueId,
  });
};
